import { TArticleMenu } from 'api/contentful/articles'
import { ArticleContentTableSection } from 'components/articles/articleContentTable/ArticleContentTableSection'
import {
  SCloseButton,
  SModalTitle,
  SModalTitleRow,
  SOverlay,
  SSectionsWrapper,
  STableWrapper,
  SToggleButton,
} from 'components/articles/articleContentTable/styled'
import { Icon } from 'components/icon'
import { Portal } from 'components/portal/Portal'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { colors } from 'utils/colors'

export function ArticleContentTable(props: { articlesMenu: TArticleMenu }) {
  const { t } = useTranslation()
  const { isLogged } = useAuth()
  const router = useRouter()
  const [tableModalVisible, setTableModalVisible] = useState(false)

  const hideTableModal = () => setTableModalVisible(false)
  const showTableModal = () => setTableModalVisible(true)

  const [expandedSectionIndex, setExpandedSectionIndex] = useState(() =>
    props.articlesMenu?.findIndex(
      (s) => !!s?.nodesCollection?.items?.find((a) => a?.article?.slug === router.query.articleSlug)
    )
  )

  const onSectionToggle = (index: number) => {
    setExpandedSectionIndex((currentIndex) => (currentIndex === index ? -1 : index))
  }

  if (!props.articlesMenu) return null
  else {
    return (
      <>
        <Portal>
          {tableModalVisible && <SOverlay onClick={hideTableModal} />}
          <STableWrapper tableModalVisible={tableModalVisible} hasLeftSidebar={!!isLogged}>
            <SModalTitleRow>
              <SModalTitle>{t('common.articles.table_of_contents')}</SModalTitle>
              <SCloseButton onClick={hideTableModal}>
                <Icon name="Close" size="1rem" color={colors.gray[500]} />
              </SCloseButton>
            </SModalTitleRow>
            <SSectionsWrapper>
              {props.articlesMenu.map((section, index) => (
                <ArticleContentTableSection
                  key={index}
                  order={index + 1}
                  section={section}
                  expanded={expandedSectionIndex === index}
                  onSectionToggle={() => onSectionToggle(index)}
                  onLinkClick={hideTableModal}
                />
              ))}
            </SSectionsWrapper>
          </STableWrapper>
        </Portal>

        <SToggleButton onClick={showTableModal}>
          <Icon name="BulletList" color="white" />
        </SToggleButton>
      </>
    )
  }
}
